export default {
  follow: 0,
  new_event: 1,
  request: 2,
  ticket_sold: 3
};
